<template>
  <v-autocomplete
    v-model="languagesSelected"
    :search-input.sync="inputTextLanguages"
    :items="autocompleteOptions"
    chips
    small-chips
    deletable-chips
    hide-details
    label="Language"
    multiple
    clearable
    return-object
    item-text="name"
    item-value="value"
    class="mb-4"
    @change="handleOnChange()"
  ></v-autocomplete>
</template>

<script>
import lodashOrderBy from "lodash/orderBy";

import { DETECTED_LANGUAGES } from "@/common/constants/language";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "SearchFilterLanguage",
  props: {
    selected: {
      type: Array,
    },
    counts: {
      type: Object,
    },
    reset: {
      type: String,
    },
  },
  data() {
    return {
      languagesSelected: [],
      inputTextLanguages: "",
      availableLanguages: [],
    };
  },
  async mounted() {
    await this.setUpLanguages();
  },
  methods: {
    handleOnChange() {
      let values = this.languagesSelected.map((language) => {
        if (Array.isArray(language.value)) {
          return language.value.flat();
        } else {
          return language.value;
        }
      });
      this.$emit(EMITTED_ACTIONS.CHANGE, [
        {
          type: "language",
          value: values,
        },
      ]);
    },
    async setUpLanguages() {
      this.availableLanguages = lodashOrderBy(
        DETECTED_LANGUAGES.map((language) => ({
          ...language,
          originalName: language.name,
        })),
        "name"
      );
      this.updateBySelected();
    },
    updateBySelected() {
      if (this.selected?.length && this.availableLanguages?.length) {
        this.languagesSelected = this.availableLanguages.filter((language) => {
          if (Array.isArray(language.value)) {
            if (language.value.some((v) => this.selected.flat().includes(v))) {
              return language;
            }
          } else {
            if (this.selected.includes(language.value)) {
              return language;
            }
          }
        });
      }
    },
  },
  computed: {
    autocompleteOptions() {
      const getCount = (value) => {
        return this.counts?.[value] != null && !Number.isNaN(this.counts[value])
          ? this.counts[value]
          : 0;
      };
      const getCounts = (values) => {
        if (Array.isArray(values)) {
          return values.reduce((partialSum, v) => partialSum + getCount(v), 0);
        } else {
          return getCount(values);
        }
      };
      const getDisplayName = (value, name) => `${name} (${getCounts(value)})`;
      return this.availableLanguages.map(({ value, name, ...rest }) => ({
        ...rest,
        value: value,
        name: getDisplayName(value, name),
      }));
    },
  },
  watch: {
    selected: {
      handler() {
        this.languagesSelected = [];
        this.updateBySelected();
      },
      deep: true,
      immediate: true,
    },
    reset: {
      handler() {
        this.languagesSelected = [];
      },
    },
  },
};
</script>
